import React, { ReactElement } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch } from 'react-redux'
import { resetUserProfile } from '@/redux/userProfile/actions'
import { auth0RedirectUri } from '@/constants'
import { setSignupProgress } from '@/redux/userConfig/actions'

const Logout = (): ReactElement<any, any> => {
  const dispatch = useDispatch()
  const { logout } = useAuth0()

  sessionStorage.clear()
  logout({
    returnTo: auth0RedirectUri,
  })
  dispatch(resetUserProfile())
  dispatch(setSignupProgress(0))

  return <div>Logging out...</div>
}

export default Logout
